import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



// Lock-in-square icon - fill-based to match design (viewBox 1008x1024)
// Lock: solid fill. Square: fillRule evenodd creates frame (outer minus inner).
const LOCK_PATH = 'M346.444 714.555h306.957v-164.418h-306.957v164.418zM588.435 383.255c0-13.403-4.553-34.928-17.414-52.052-11.374-15.141-31.527-30.156-71.088-30.158-39.567 0-59.734 15.017-71.107 30.158-12.86 17.123-17.414 38.649-17.414 52.052v82.191h177.023v-82.191zM671.281 465.701c36.357 2.965 64.95 34.055 64.95 71.992v189.305c0 39.898-31.621 72.249-70.642 72.249h-331.332c-39.014-0.005-70.642-32.352-70.642-72.249v-189.305c0-37.942 28.607-69.033 64.967-71.992v-82.446c0-28.113 8.427-68.876 34.545-103.648 27.605-36.754 72.425-63.253 136.805-63.253 64.373 0.002 109.18 26.503 136.786 63.253 26.118 34.772 34.562 75.535 34.562 103.648v82.446z';
const SQUARE_PATH = 'M904.008 168.606c-0.003-31.486-25.528-57.010-57.013-57.013h-694.143c-31.485 0.003-57.010 25.528-57.013 57.013v694.143c0.003 31.486 25.527 57.010 57.013 57.013h694.143c31.487-0.003 57.010-25.526 57.013-57.013v-694.143zM988.292 862.748c-0.003 78.037-63.261 141.295-141.298 141.298h-694.143c-78.035-0.003-141.295-63.26-141.298-141.298v-694.143c0.003-78.036 63.262-141.295 141.298-141.298h694.143c78.038 0.003 141.295 63.262 141.298 141.298v694.143z';

const LockInSquareIconBuilder: IconBuilder = {
	icon: ({ color = '#89c32e' }) => (
		<g
			fill={color}
			fillRule="evenodd"
		>
			<path d={LOCK_PATH} />
			<path d={SQUARE_PATH} />
		</g>
	),
	viewBoxHeight: 1024,
	viewBoxWidth: 1008,
};



export default LockInSquareIconBuilder;
